/*============================================================================
  Iron — barre d'ajout au panier collante (mobile), fiche produit.
  - Relaie le clic vers le vrai bouton [data-add-to-cart] (chemin AJAX natif).
  - Miroir du prix principal [data-product-price] (suit les changements de variante).
  - S'affiche quand le vrai bouton a défilé au-dessus de l'écran (IntersectionObserver).
  - No-op si la barre [data-iron-sticky-atc] n'est pas présente (hors PDP).
==============================================================================*/
(function () {
  if (window.IronStickyATC) return;
  window.IronStickyATC = true;

  function init() {
    var bar = document.querySelector('[data-iron-sticky-atc]');
    if (!bar) return;

    // Premier match = produit principal (rendu avant les reco / recently-viewed dans le DOM).
    var realAdd = document.querySelector('[data-add-to-cart]');
    var mainPrice = document.querySelector('[data-product-price]');
    var stickyPrice = bar.querySelector('[data-iron-sticky-price]');
    var stickyAdd = bar.querySelector('[data-iron-sticky-add]');

    // Reparente sur <body> : évite tout clipping par un ancêtre transformé / overflow.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);

    if (mainPrice && stickyPrice) {
      var syncPrice = function () { stickyPrice.innerHTML = mainPrice.innerHTML; };
      syncPrice();
      new MutationObserver(syncPrice).observe(mainPrice, { childList: true, subtree: true, characterData: true });
    }

    if (stickyAdd && realAdd) {
      var reflect = function () {
        stickyAdd.disabled = !!realAdd.disabled;
        var txt = realAdd.querySelector('[data-add-to-cart-text]');
        if (txt) stickyAdd.textContent = txt.textContent.trim();
      };
      reflect();
      new MutationObserver(reflect).observe(realAdd, { attributes: true, childList: true, subtree: true });

      stickyAdd.addEventListener('click', function (e) {
        e.preventDefault();
        if (realAdd.disabled) return;
        realAdd.click();
      });
    }

    if ('IntersectionObserver' in window && realAdd) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(realAdd);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
